import {DateField, Panes, Select, TextField} from '@management-ui/core';
import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import CurrencySelect from '../../../../components/CurrencySelect';
import {ServiceContext} from '../../../../components/Services';
import {saveDate} from '../../../../utilities';

const Core = ({order = {}, prefix = ''}) => {
  const services = useContext(ServiceContext);
  const [suppliers, setSuppliers] = useState([]);
  const optionsLoaded = useRef(false);

  useEffect(() => {
    if (!optionsLoaded.current) {
      optionsLoaded.current = true;
      services.contact.getContacts({suppliers: '1'}, 1, 500).then((list) => {
        setSuppliers(list.data.map(({id, name}) => ({title: name, value: id})));
      }).catch(() => null);
    }
  }, [services]);

  const handleReset = useCallback((subject) => {
    if (subject.supplier) {
      subject.supplier_id = `${subject.supplier.id}`;
    }
    return subject;
  }, []);

  return (
    <Panes
      entity={order}
      prefix={prefix}
      onReset={handleReset}
      panes={[
        {
          title: 'Core Order Details',
          fields: [
            <DateField
              name="date"
              prefix={prefix}
              label="Date"
              rules={{required: 'Please select a date for this order'}}
            />,
            <Select
              name="supplier_id"
              prefix={prefix}
              label="Supplier"
              options={suppliers}
              rules={{required: 'Please select a supplier'}}
            />,
            <TextField
              name="number"
              prefix={prefix}
              label="PO Number (if left blank this will be auto-generated)"
            />,
            <CurrencySelect
              prefix={prefix}
            />,
            <TextField
              name="load_number"
              prefix={prefix}
              label="Load Number"
            />,
          ]
        },
        {
          title: '',
          fields: []
        }
      ]}
      title=""/>
  );
};

Core.onSave = ({date, supplier_id, number, currency, load_number}) => ({
  date: saveDate(date),
  supplier_id,
  number,
  currency: currency ?? 'GBP',
  load_number
});

export default Core;
